import { render, staticRenderFns } from "./OptInBanner.vue?vue&type=template&id=50fd99d8&"
import script from "./OptInBanner.vue?vue&type=script&lang=js&"
export * from "./OptInBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports